export const GET_FREE_HOURS = 'GET_FREE_HOURS'
export const GET_HOURS_TOODAY = 'GET_HOURS_TOODAY'
export const GET_WSP_MSG = 'GET_WSP_MSG'
export const EDIT_WSP_MESSAGE = 'EDIT_WSP_MESSAGE'
export const FIND_USER = 'FIND_USER'
export const HANDLE_CHANGE = 'HANDLE_CHANGE'
export const GET_PRICE = 'GET_PRICE'